// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";

var sourceSchema = S.union([
      S.literal("STUDENT_MISSIONS"),
      S.literal("MY_WORDS"),
      S.literal("LC"),
      S.shape(S.string, (function (s) {
              return s;
            }))
    ]);

var schema = S.union([
      S.object(function (s) {
            s.tag("kind", "BadgeTrophies");
            return {
                    TAG: "BadgeTrophies",
                    source: s.f("source", sourceSchema),
                    earned: s.f("value", S.$$int)
                  };
          }),
      S.object(function (s) {
            s.tag("kind", "BadgeGems");
            return {
                    TAG: "BadgeGems",
                    balance: s.f("value", S.$$int)
                  };
          }),
      S.object(function (s) {
            s.tag("kind", "BadgeActivitiesCompleted");
            return {
                    TAG: "BadgeActivitiesCompleted",
                    source: s.f("source", sourceSchema),
                    completed: s.f("value", S.$$int)
                  };
          }),
      S.object(function (s) {
            s.tag("kind", "BadgeArcade");
            return {
                    TAG: "BadgeArcade",
                    code: s.f("value", S.string)
                  };
          }),
      S.object(function (s) {
            s.tag("kind", "BadgeDate");
            return {
                    TAG: "BadgeDate",
                    date: s.f("value", S.string)
                  };
          }),
      S.object(function (s) {
            s.tag("kind", "BadgeHighFives");
            return {
                    TAG: "BadgeHighFives",
                    _0: s.f("value", S.$$int)
                  };
          }),
      S.object(function (s) {
            s.tag("kind", "BadgeThumbsUp");
            return {
                    TAG: "BadgeThumbsUp",
                    _0: s.f("value", S.$$int)
                  };
          }),
      S.object(function (param) {
            return "BadgeUnknown";
          })
    ]);

var Data = {
  sourceSchema: sourceSchema,
  schema: schema
};

function stringifyData(__x) {
  return S.reverseConvertToJsonOrThrow(__x, schema);
}

function parseJsonData(__x) {
  return S.parseJsonOrThrow(__x, schema);
}

function testAwards(badges, input) {
  return badges.filter(function (badge) {
              if (badge.collected) {
                return false;
              }
              var given = badge.rule;
              if (typeof given !== "object") {
                return false;
              }
              switch (given.TAG) {
                case "BadgeTrophies" :
                    var earned = given.earned;
                    var source = given.source;
                    return input.some(function (t) {
                                if (t.TAG === "TrophyCount" && Caml_obj.equal(t.source, source)) {
                                  return t.gold >= earned;
                                } else {
                                  return false;
                                }
                              });
                case "BadgeGems" :
                    var balance = given.balance;
                    return input.some(function (t) {
                                if (t.TAG === "GemsSaved") {
                                  return t.gems >= balance;
                                } else {
                                  return false;
                                }
                              });
                case "BadgeActivitiesCompleted" :
                    var completed = given.completed;
                    var source$1 = given.source;
                    return input.some(function (t) {
                                if (t.TAG === "MissionCompleteCount" && Caml_obj.equal(t.source, source$1)) {
                                  return t.count >= completed;
                                } else {
                                  return false;
                                }
                              });
                case "BadgeArcade" :
                    var code = given.code;
                    return input.some(function (t) {
                                if (t.TAG === "ArcadeAchievement") {
                                  return t.code === code;
                                } else {
                                  return false;
                                }
                              });
                case "BadgeDate" :
                    var date = given.date;
                    return input.some(function (t) {
                                if (t.TAG === "DateAchievement") {
                                  return t.isToday(date);
                                } else {
                                  return false;
                                }
                              });
                case "BadgeHighFives" :
                    var given$1 = given._0;
                    return input.some(function (t) {
                                if (t.TAG === "HighFivesAchievement") {
                                  return t.given >= given$1;
                                } else {
                                  return false;
                                }
                              });
                case "BadgeThumbsUp" :
                    var given$2 = given._0;
                    return input.some(function (t) {
                                if (t.TAG === "ThumbsUpAchievement") {
                                  return t.given >= given$2;
                                } else {
                                  return false;
                                }
                              });
                
              }
            });
}

export {
  Data ,
  stringifyData ,
  parseJsonData ,
  testAwards ,
}
/* sourceSchema Not a pure module */
